import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef, EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {FRCWidgetCompleteEventName, FriendlyCaptchaSDK, WidgetHandle} from "@friendlycaptcha/sdk";
import {
    CaptchaActionNames,
    DistinguishSupportService,
    FriendlyCaptchaService,
    FriendlyCaptchaStatus,
    UserService
} from "../../../shared";
import {environment} from "../../../../../environments/environment";

@Component({
    selector: 'sl-friendly-captcha-widget',
    templateUrl: './friendly-captcha-widget.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FriendlyCaptchaWidgetComponent implements OnInit, AfterViewInit {
    @ViewChild('captchaContainer', {static: true}) captchaContainer: ElementRef;
    @Input() actionName: CaptchaActionNames;
    @Input() className: string;
    @Output() friendlyCaptchaOut: EventEmitter<FriendlyCaptchaStatus> = new EventEmitter<FriendlyCaptchaStatus>();

    public friendlyCaptchaStatus: FriendlyCaptchaStatus;

    private captchaWidget: WidgetHandle;
    private sdk: FriendlyCaptchaSDK;
    private viewReady = false;

    /**
     *
     * @param {FriendlyCaptchaService} friendlyCaptchaService
     * @param {UserService} userService
     * @param {DistinguishSupportService} distinguishSupportService
     */
    constructor(private friendlyCaptchaService: FriendlyCaptchaService,
                private userService: UserService,
                private distinguishSupportService: DistinguishSupportService) {
    }

    ngOnInit() {
        this.getCurrentUserStatus();
    }

    ngAfterViewInit() {
        this.viewReady = true;
        this.mountFriendlyCaptcha();
    }

    public resetWidget() {
        this.captchaWidget.reset();
    }

    public shouldRender(): boolean {
        return this.friendlyCaptchaStatus?.enabled && this.friendlyCaptchaStatus?.actionNames.includes(this.actionName) && !this.distinguishSupportService.support;
    }

    private mountFriendlyCaptcha(): void {
        if (!this.viewReady) return;
        if (!this.shouldRender()) return;

        this.sdk = new FriendlyCaptchaSDK({apiEndpoint: 'global'});

        // Create the widget
        setTimeout(() => {
            this.captchaWidget = this.sdk.createWidget({
                    element: this.captchaContainer?.nativeElement,
                    sitekey: this.friendlyCaptchaStatus.siteKey,
                    startMode: 'auto'
                }
            );

            // Listen for completion event
            this.captchaWidget.addEventListener(FRCWidgetCompleteEventName, (event: any) => {
                const solution = event.detail.response; // FRCWidgetCompleteEventData.solution
                this.friendlyCaptchaService.setToken(solution);
            });

            this.captchaWidget.addEventListener("frc:widget.error", (e: any) => {
                console.log("Friendly Captcha error:", e.detail);
            });
        }, 1000);
    }

    private getCurrentUserStatus() {
        this.userService.getCurrentUserStatus().subscribe(
            currUserStatus => {
                this.friendlyCaptchaStatus = currUserStatus?.friendlyCaptcha;
                this.friendlyCaptchaOut.emit(this.friendlyCaptchaStatus);
                this.mountFriendlyCaptcha();
            });
    }
}
